import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section className="bg-sand px-4 py-16 md:py-24" data-id="element-110" data-mp="1mfki0z51lre9">
      <Reveal className="mx-auto max-w-3xl" data-id="element-111" data-mp="1hoc9047mk81m">
        <div className="mb-10 text-center" data-id="element-112" data-mp="1hmj00i9jhbqg">
          <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-113" data-mp="1wcylly5valp5">
            SUBITO DOPO IL PAGAMENTO
          </p>
          <h2 className="text-3xl font-bold tracking-tight text-petrol md:text-4xl" data-id="element-114" data-mp="1rddlhkeyo7au">Cosa ricevi</h2>
        </div>
        <ul className="space-y-3" data-id="element-115" data-mp="25cvds9rgu2oy">
          {instantAccessItems.map(item => <li key={item} className="flex items-start gap-4 rounded-xl border border-line bg-white p-5 shadow-soft" data-id="element-116" data-mp="20f3euvselgb9">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage/15 text-sage" data-id="element-117" data-mp="612eg6h7gl92">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-118" data-mp="2n2zvrpbm3y9h" />
              </span>
              <span className="text-sm font-medium leading-snug text-petrol sm:text-base" data-id="element-119" data-mp="2s1jl7zpezs6l">{item}</span>
            </li>)}
        </ul>
        <div className="mt-10 flex flex-col items-center" data-id="element-120" data-mp="2wy09ctwm66jo">
          <CTAButton className="w-full max-w-md py-5 text-base md:text-lg" data-id="element-121" data-mp="31s4er8q8e6in" />
          <p className="mt-4 text-center font-note text-xs leading-relaxed text-muted" data-id="element-122" data-mp="35sy5sayz01fr">
            Download immediato in PDF · Pagamento unico di 19 € · Garanzia soddisfatti o rimborsati di 30 giorni
          </p>
        </div>
      </Reveal>
    </section>;
}